import { Translate } from '@chipinside/translate'
import { Box, Checkbox, Tooltip } from '@mui/material'
import { isEmpty } from 'lodash'

type RoutePermissionValue = {
  status: 'all' | 'some' | 'none'
  text: string
} | null

const TypeRoutePermissions = ({ value }: { value: RoutePermissionValue }) => {
  if (isEmpty(value)) return null

  const { status, text } = value

  return (
    <Tooltip
      title={Translate({
        messageKey: ['permission_plural', text],
        separator: ': ',
        translate: [true, false],
      })}
      arrow
    >
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Checkbox checked={status === 'all'} indeterminate={status === 'some'} disabled />
      </Box>
    </Tooltip>
  )
}

export { TypeRoutePermissions }
